export const socialLinkInstagram = 'https://www.instagram.com/cloud-solutions';
export const socialLinkLinkedIn = 'https://www.linkedin.com/company/cloud-solutions';
export const socialLinkTwitter = 'https://www.twitter.com/@_cs_platform_';
export const socialLinkFacebook = 'https://www.facebook.com/cloud-solutions';
export const contactEmail = 'contact@cloud-solutions.io';
export const supportEmail = 'support@cloud-solutions.io';
export const mainDomain = 'https://cloud-solutions.io';
export const twitterSite = '@_cs_platform_';
